// Campaign parameters we drop from the address bar once analytics has read them.
//
// These must survive the request: a server-side redirect that strips them runs before
// gtag loads, so GA never sees the campaign and the visit lands in "Direct". The URL is
// cleaned client-side instead, after the landing page_view is sent.
export const TRACKING_SEARCH_PARAMS = [
  'fbclid',
  'gclid',
  'mc_cid',
  'mc_eid',
  'ref',
  'utm_campaign',
  'utm_content',
  'utm_medium',
  'utm_source',
  'utm_term',
] as const;
